<template>
  <svg :width="width" :height="height" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.6421 4C16.1829 4 15 5.18289 15 6.64206V71.7439C15 72.2962 14.5523 72.7439 14 72.7439C13.4477 72.7439 13 72.2962 13 71.7439V6.64206C13 4.07832 15.0783 2 17.6421 2H66.8099C69.3736 2 71.452 4.07832 71.452 6.64206V64.9151C71.452 67.4788 69.3736 69.5571 66.8099 69.5571H27.6577C27.1054 69.5571 26.6577 69.1094 26.6577 68.5571C26.6577 68.0048 27.1054 67.5571 27.6577 67.5571H66.8099C68.2691 67.5571 69.452 66.3742 69.452 64.9151V6.64206C69.452 5.18289 68.2691 4 66.8099 4H17.6421Z"
      :fill="outlineColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.21 17.113C31.21 16.5607 31.6577 16.113 32.21 16.113H52.2413C52.7936 16.113 53.2413 16.5607 53.2413 17.113C53.2413 17.6653 52.7936 18.113 52.2413 18.113H32.21C31.6577 18.113 31.21 17.6653 31.21 17.113Z"
      :fill="outlineColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.6582 24.3971C25.6582 23.2926 26.5536 22.3971 27.6582 22.3971H56.7947C57.8993 22.3971 58.7947 23.2926 58.7947 24.3971C58.7947 25.5017 57.8993 26.3971 56.7947 26.3971H27.6582C26.5536 26.3971 25.6582 25.5017 25.6582 24.3971Z"
      :fill="outlineColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.6582 31.226C26.6582 30.6737 27.1059 30.226 27.6582 30.226H56.7947C57.347 30.226 57.7947 30.6737 57.7947 31.226C57.7947 31.7783 57.347 32.226 56.7947 32.226H27.6582C27.1059 32.226 26.6582 31.7783 26.6582 31.226Z"
      :fill="outlineColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5527 9.37361C17.5527 7.8156 18.8158 6.55258 20.3738 6.55258H64.0785C65.6365 6.55258 66.8995 7.8156 66.8995 9.37361V62.1835C66.8995 63.7415 65.6365 65.0045 64.0785 65.0045H20.3738C18.8158 65.0045 17.5527 63.7415 17.5527 62.1835V9.37361ZM20.3738 8.55258C19.9203 8.55258 19.5527 8.92017 19.5527 9.37361V62.1835C19.5527 62.637 19.9203 63.0045 20.3738 63.0045H64.0785C64.532 63.0045 64.8995 62.637 64.8995 62.1835V9.37361C64.8995 8.92017 64.532 8.55258 64.0785 8.55258H20.3738Z"
      :fill="outlineColor"
    />
    <path
      d="M15 64.7065C15 64.1543 14.5523 63.7065 14 63.7065C13.4477 63.7065 13 64.1543 13 64.7065V73.1097C13 76.1763 15.486 78.6623 18.5526 78.6623H21.2842V76.6623H18.5526C16.5905 76.6623 15 75.0717 15 73.1097C15 71.1477 16.5905 69.5571 18.5526 69.5571H21.2842V68.5571H30.3893V69.5571H66.6139L66.5886 69.6225C66.2417 70.5295 65.8696 71.798 65.8696 73.1097C65.8696 74.4214 66.2417 75.6899 66.5886 76.5969L66.6139 76.6623H30.3893V78.6623H68.1757L68.1806 78.6623H68.452C69.0042 78.6623 69.452 78.2146 69.452 77.6623C69.452 77.2407 69.1911 76.8801 68.822 76.733C68.7169 76.5136 68.5868 76.2226 68.4566 75.8823C68.1505 75.0821 67.8696 74.0743 67.8696 73.1097C67.8696 72.1451 68.1505 71.1373 68.4566 70.3371C68.607 69.9441 68.7573 69.6168 68.8689 69.3897C68.9246 69.2764 68.9703 69.1889 69.0011 69.1315C69.0165 69.1028 69.0281 69.0817 69.0353 69.0687L69.0432 69.0545L69.0438 69.0535C69.2206 68.7443 69.2196 68.3643 69.041 68.056C68.8622 67.7472 68.5325 67.5571 68.1757 67.5571H18.5526C17.2013 67.5571 15.9628 68.0398 15 68.8422V64.7065Z"
      :fill="outlineColor"
    />
    <path d="M27.8518 78.6623L26.4232 76.6623H25.2503L23.8217 78.6623H27.8518Z" :fill="outlineColor" />
    <path d="M25.7728 75.9307H25.9007L25.8368 75.8413L25.7728 75.9307Z" :fill="outlineColor" />
    <path
      d="M30.3893 75.9307H63.6227C64.175 75.9307 64.6227 75.483 64.6227 74.9307C64.6227 74.3784 64.175 73.9307 63.6227 73.9307H30.3893V75.9307Z"
      :fill="outlineColor"
    />
    <path
      d="M30.3893 72.7439H63.6227C64.175 72.7439 64.6227 72.2962 64.6227 71.7439C64.6227 71.1916 64.175 70.7439 63.6227 70.7439H30.3893V72.7439Z"
      :fill="outlineColor"
    />
    <path
      d="M21.2842 70.7439V72.7439H19.918C19.3657 72.7439 18.918 72.2962 18.918 71.7439C18.918 71.1916 19.3657 70.7439 19.918 70.7439H21.2842Z"
      :fill="outlineColor"
    />
    <path
      d="M21.2842 73.9307V75.9307H19.918C19.3657 75.9307 18.918 75.483 18.918 74.9307C18.918 74.3784 19.3657 73.9307 19.918 73.9307H21.2842Z"
      :fill="outlineColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M68.1758 69.5571H18.5526V67.5571H68.1757L68.1758 69.5571Z"
      :fill="outlineColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2842 68.5571C20.2842 68.0048 20.7319 67.5571 21.2842 67.5571H30.3893C30.9416 67.5571 31.3893 68.0048 31.3893 68.5571V82.2149C31.3893 82.6496 31.1085 83.0345 30.6945 83.1672C30.2805 83.2998 29.8283 83.1498 29.5756 82.7961L25.8368 77.5617L22.0979 82.7961C21.8452 83.1498 21.393 83.2998 20.979 83.1672C20.565 83.0345 20.2842 82.6496 20.2842 82.2149V68.5571ZM22.2842 69.5571V79.0944L25.023 75.26C25.2107 74.9972 25.5138 74.8413 25.8368 74.8413C26.1597 74.8413 26.4628 74.9972 26.6505 75.26L29.3893 79.0944V69.5571H22.2842Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'BookIllustration',
  props: {
    width: {
      type: Number,
      default: 84,
    },
    height: {
      type: Number,
      default: 84,
    },
    outlineColor: {
      type: String,
      default: '#05070F',
    },
  },
};
</script>
